import { combineReducers } from 'redux'
import profileReducer from './profileReducer'
import accessReducer from './accessReducer'
import userReducer from './userReducer'
import notificationReducer from './notificationReducer'
import servicesReducer from './servicesReducer'
import authReducer from './authReducer'
import secreteryReducer from './secreteryReducer'
import commonReducer from './commonReducer'
import ivrReducer from './ivrReducer'
import documentReducer from './documentsReducer'
import callReportReducer from './callReportReducer'
import companyReducer from './companyReducer'
import { appRouteDetection } from '../../components/helper'
import lineSettingsReducer from './lineSettingsReducer'
import transactionReducer from './transactionReducer'
import chargeReducer from './chargeReducer'
import purchaseReducer from './purchaseReducer'
import queueReducer from './queueReducer'
import customerAttachmentsReducer from './customerAttachmentsReducer'
import secretaryMessageReducer from './secretaryMessageReducer'
import customerReducer from './customerReducer'
import faxReducer from './faxReducer'
import tsAuthReducer from './Auth_Reducer'
import callQueueReportReducer from './callQueueReportReducer'
import voiceMailReducer from './voiceMailReducer'
import contactReducer from './contactReducer'
import dashboardReducer from './dashboardReducer'
import calendarHoliday from './calendarHolidayReducer'
import outGoingReducer from './outGoingReducer'
import ticketReducer from './ticketReducer'
import callRatingReducer from "./callRatingReducer"
import outGoingCallOnsecretaryReducer from "./outGoingCallOnsecretaryReducer"


const initialState = {
  sidebarShow: true,//!appRouteDetection(),
  userState: 'green',
  show:false,
  number:''
}
const callDirect = (state = initialState, { type, ...rest }) => {
    switch (type) {
    case 'callDirect':
      return { ...state, ...rest }
    default:
      return state
  }
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const userState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'userState':
      return { ...state, ...rest }
    default:
      return state
  }
}
const rootReducer = combineReducers({
  userReducer,
  profileReducer,
  callDirect,
  changeState,
  accessReducer,
  userState,
  notificationReducer,
  servicesReducer,
  authReducer,
  secreteryReducer,
  commonReducer,
  ivrReducer,
  documentReducer,
  callReportReducer,
  lineSettingsReducer,
  chargeReducer,
  companyReducer,
  purchaseReducer,
  transactionReducer,
  queueReducer,
  customerAttachmentsReducer,
  secretaryMessageReducer,
  customerReducer,
  faxReducer,
  tsAuthReducer,
  callQueueReportReducer,
  voiceMailReducer,
  contactReducer,
  ticketReducer,
  dashboardReducer,
  calendarHoliday,
  outGoingReducer,
  callRatingReducer,
  outGoingCallOnsecretaryReducer
})

export default rootReducer


